import { CLOSE_ALL_OVERLAYS, OPEN_SEARCH_OVERLAY } from "layout/redux/overlay.actions";
// import { useAppDispatch, useAppSelector } from "app/redux/store";
import { useDispatch, useSelector } from "react-redux";

export default () => {
    const dispatch = useDispatch();
    const overlay = useSelector(state => state.overlay);

    const toggleSearchOverlay = () => {
        setTimeout(() => {
            if (overlay.currentOverlay !== "SEARCH_OVERLAY") {
                dispatch({
                    type: OPEN_SEARCH_OVERLAY
                });
            }
            else {
                dispatch({
                    type: CLOSE_ALL_OVERLAYS
                });
            }
        }, 50);
    };

    return { toggleSearchOverlay };
};